import { render, staticRenderFns } from "./Halfday.vue?vue&type=template&id=58242f56&scoped=true"
import script from "./Halfday.vue?vue&type=script&lang=js"
export * from "./Halfday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58242f56",
  null
  
)

export default component.exports